import React, { useContext, useState } from 'react';

import { Button, TextField, Typography } from '@riac/design-system';
import { IControlledWLItem, IWLItem } from 'src/components/Wishlists/Wishlist.i';
import { formatCurrency } from 'src/lib/catalog';
import { WishlistActionContext } from 'src/lib/WishlistActionContext';
import { BiddingContext } from 'src/lib/BiddingContext';

// parent handles Notes field state
export const ControlledWLItem = (props: IControlledWLItem) => {
  const { notes, setNotes, notesOpen, item } = props;
  const [editNotes, setEditNotes] = useState(notesOpen ? true : false);
  const { saveWishlistItemNotes, deleteWishlistItem } = useContext(WishlistActionContext);
  const img = `${window.CDN_PATH}${item.AuctionID}/thumbs/${item.LotNumber}.jpg`;
  const link = `/detail/${item.AuctionID}/${item.LotNumber}`;
  const { auctionTypeId } = useContext(BiddingContext);
  return (
    <div>
      <div className='flex flex-col sm:flex-row gap-3'>
        <Button unstyled to={link}>
          <img src={img} alt={`Rock Island Auction Company Lot Number ${item.LotNumber}`} />
        </Button>
        <div className='flex flex-1 flex-col gap-1'>
          <Button unstyled to={link}>
            <Typography size='lg' color='text-lighter' weight='bold'>Lot {item.LotNumber}</Typography>
          </Button>
          <Button unstyled to={link}>
            <Typography heading size='sm' weight='bold' tag='h2'>{item.Headline}</Typography>
          </Button>
          {auctionTypeId !== TIMED_AUCTION_TYPE_ID
          && <Typography size='md' weight='bold'>
            Estimated Price:{' '}
            <span className='font-normal'>
              {formatCurrency(item.LowEst)} -{formatCurrency(item.HighEst)}
            </span>
          </Typography>
          }
          {notes && !editNotes && (
            <Typography>
              {notes}
            </Typography>
          )}
          {editNotes ? (
            <div className='flex flex-col gap-2'>
              <TextField
                label='Notes:'
                type='textarea'
                value={notes || ''}
                multiline
                rows={3}
                onChange={(e) => setNotes(e)}
              />
              {props.type === 'view' ? (
                <Button
                  className='self-start'
                  onPress={() => {
                    saveWishlistItemNotes(item.WishListItemID, notes);
                    setEditNotes(false);
                  }}
                >
                  Save
                </Button>
              ) : null}
            </div>
          ) : (
            <div className='flex flex-row gap-4'>
              <Button variant='link' className='p-0 no-underline' onPress={() => setEditNotes((status) => !status)}>
                {notes?.length > 0 ? 'Edit' : 'Add'} Note
              </Button>
              {props.type === 'view' ? (
                <Button
                  title='Remove Item'
                  variant='link' className='p-0 no-underline text-error hover:text-error-hover active:text-error-active' 
                  onPress={() => {
                    deleteWishlistItem(item.WishListItemID, props.wishlistId, item.AuctionItemID);
                    props.removeFromList(item.WishListItemID);
                  }}
                >
                  Remove
                </Button>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// WL item with self-contained Notes state
export const WLItem = (props: IWLItem) => {
  const [note, setNote] = useState(props.item.Notes);
  return (
    <ControlledWLItem
      type='view'
      notes={note}
      setNotes={setNote}
      notesOpen={false}
      item={props.item}
      wishlistId={props.wishlistId}
      removeFromList={props.removeFromList}
    />
  );
};
